import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface BooleanFieldProps {
  label: string;
  name: string;
}

export const BooleanField = ({ name, label }: BooleanFieldProps) => {
  const { getFormItemProps } = useFormItem();
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  return (
    <Form.Item
      name={name}
      label={label}
      shouldToggleValueOnLabelClick
      {...getFormItemProps({
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        className: classNames("!items-center", {
          "!flex justify-between": !isPropertiesPanelV2,
          "!grid !mb-0": isPropertiesPanelV2,
        }),
      })}
    >
      <Form.ToggleSwitch
        name={name}
        variant="small"
        labelClassName={classNames({
          "mb-0": isPropertiesPanelV2,
        })}
      />
    </Form.Item>
  );
};
